module.exports = __webpack_public_path__ + "static/media/addEventIcon.3b589068.svg";